import type { ReportCategories } from '../../../../common/enums/reportCategories';
import type { ServiceCode } from '../../../../common/enums/serviceCode';
import type { ServiceType } from '../../../../common/enums/serviceType';
import type {
    ICustomControlDiagnosticReportAddEditProps,
    ICustomControlProcedureDiagnosticReportAddEditProps,
    ICustomControlProcedureDiagnosticReportReadProps,
    ICustomControlProcedureReadProps,
    ICustomControlRequestAddEditProps,
    ICustomControlSupervisionEditProps,
    ICustomControlSupervisionReadProps,
} from './interfaces/';
import type { ICustomControlDiagnosticReportReadProps } from './interfaces/customControlDiagnosticReportReadProps';
import type { ICustomControlProcedureAddEditProps } from './interfaces/customControlProcedureAddEditProps';
import type { ICustomControlRequestReadProps } from './interfaces/customControlRequestReadProps';
import { CustomControlEntity } from '../../../../common/enums/customControlEntity';
import { FormParagraph } from '../../elements/common';
import { DermaCV1DiagnosticReportAddEdit } from './DermaC/v1/DermaCV1DiagnosticReportAddEdit';
import { DermaCV1DiagnosticReportRead } from './DermaC/v1/DermaCV1DiagnosticReportRead';
import { DermaCV1RequestAddEdit } from './DermaC/v1/DermaCV1RequestAddEdit';
import { DermaCV1RequestRead } from './DermaC/v1/DermaCV1RequestRead';
import { DermaCscV1DiagnosticReportAddEdit } from './DermaCsc/v1/DermaCscV1DiagnosticReportAddEdit';
import { DermaCscV1DiagnosticReportRead } from './DermaCsc/v1/DermaCscV1DiagnosticReportRead';
import { DermaCscV1RequestAddEdit } from './DermaCsc/v1/DermaCscV1RequestAddEdit';
import { DermaCscV1RequestRead } from './DermaCsc/v1/DermaCscV1RequestRead';
import { DermaCwondV1DiagnosticReportAddEdit } from './DermaCwond/v1/DermaCwondV1DiagnosticReportAddEdit';
import { DermaCwondV1DiagnosticReportRead } from './DermaCwond/v1/DermaCwondV1DiagnosticReportRead';
import { DermaCwondV1RequestAddEdit } from './DermaCwond/v1/DermaCwondV1RequestAddEdit';
import { DermaCwondV1RequestRead } from './DermaCwond/v1/DermaCwondV1RequestRead';
import { DermaOthV1DiagnosticReportAddEdit } from './DermaOth/v1/DermaOthV1DiagnosticReportAddEdit';
import { DermaOthV1DiagnosticReportRead } from './DermaOth/v1/DermaOthV1DiagnosticReportRead';
import { DermaOthV1ProcedureRead } from './DermaOth/v1/DermaOthV1ProcedureRead';
import { DermaOthV1RequestAddEdit } from './DermaOth/v1/DermaOthV1RequestAddEdit';
import { DermaOthV1RequestRead } from './DermaOth/v1/DermaOthV1RequestRead';
import { DermaSnelCV1DiagnosticReportAddEdit } from './DermaSnelC/v1/DermaSnelCV1DiagnosticReportAddEdit';
import { DermaSnelCV1DiagnosticReportRead } from './DermaSnelC/v1/DermaSnelCV1DiagnosticReportRead';
import { DermaSnelCV1RequestAddEdit } from './DermaSnelC/v1/DermaSnelCV1RequestAddEdit';
import { DermaSnelCV1RequestRead } from './DermaSnelC/v1/DermaSnelCV1RequestRead';
import { DermaSnelCscV1DiagnosticReportAddEdit } from './DermaSnelCsc/v1/DermaSnelCscV1DiagnosticReportAddEdit';
import { DermaSnelCscV1DiagnosticReportRead } from './DermaSnelCsc/v1/DermaSnelCscV1DiagnosticReportRead';
import { DermaSnelCscV1RequestAddEdit } from './DermaSnelCsc/v1/DermaSnelCscV1RequestAddEdit';
import { DermaSnelCscV1RequestRead } from './DermaSnelCsc/v1/DermaSnelCscV1RequestRead';
import { GgzbMindV1RequestRead } from './GGZBmind/v1/GgzbMindV1RequestRead';
import { GgzbTherV1RequestAddEdit } from './GGZBther/v1/GgzbTherV1RequestAddEdit';
import { GgzbTherV1RequestRead } from './GGZBther/v1/GgzbTherV1RequestRead';
import { Ggzcf2fV1DiagnosticReportAddEdit } from './GGZCf2f/v1/Ggzcf2fV1DiagnosticReportAddEdit';
import { Ggzcf2fV1DiagnosticReportRead } from './GGZCf2f/v1/Ggzcf2fV1DiagnosticReportRead';
import { Ggzcf2fV1RequestAddEdit } from './GGZCf2f/v1/Ggzcf2fV1RequestAddEdit';
import { Ggzcf2fV1RequestRead } from './GGZCf2f/v1/Ggzcf2fV1RequestRead';
import { GgzcgV1DiagnosticReportAddEdit } from './GGZCg/v1/GgzcgV1DiagnosticReportAddEdit';
import { GgzcgV1DiagnosticReportRead } from './GGZCg/v1/GgzcgV1DiagnosticReportRead';
import { GgzcgV1RequestAddEdit } from './GGZCg/v1/GgzcgV1RequestAddEdit';
import { GgzcgV1RequestRead } from './GGZCg/v1/GgzcgV1RequestRead';
import { GgzcmdoV1DiagnosticReportAddEdit } from './GGZCmdo/v1/GgzcmdoV1DiagnosticReportAddEdit';
import { GgzcmdoV1DiagnosticReportRead } from './GGZCmdo/v1/GgzcmdoV1DiagnosticReportRead';
import { GgzcmdoV1RequestAddEdit } from './GGZCmdo/v1/GgzcmdoV1RequestAddEdit';
import { GgzcmdoV1RequestRead } from './GGZCmdo/v1/GgzcmdoV1RequestRead';
import { GgzctV1DiagnosticReportAddEdit } from './GGZCt/v1/GgzctV1DiagnosticReportAddEdit';
import { GgzctV1DiagnosticReportRead } from './GGZCt/v1/GgzctV1DiagnosticReportRead';
import { GgzctV1RequestAddEdit } from './GGZCt/v1/GgzctV1RequestAddEdit';
import { GgzctV1RequestRead } from './GGZCt/v1/GgzctV1RequestRead';
import { GgzctriageV1DiagnosticReportAddEdit } from './GGZCtriage/v1/GgzctriageV1DiagnosticReportAddEdit';
import { GgzctriageV1DiagnosticReportRead } from './GGZCtriage/v1/GgzctriageV1DiagnosticReportRead';
import { GgzctriageV1RequestAddEdit } from './GGZCtriage/v1/GgzctriageV1RequestAddEdit';
import { GgzctriageV1RequestRead } from './GGZCtriage/v1/GgzctriageV1RequestRead';
import { GgzoEmblV1DiagnosticReportRead } from './GGZOembl/v1/GgzoEmblV1DiagnosticReportRead';
import { GgzoEmblV1ProcedureRead } from './GGZOembl/v1/GgzoEmblV1ProcedureRead';
import { GgzoEmblV1RequestAddEdit } from './GGZOembl/v1/GgzoEmblV1RequestAddEdit';
import { GgzoEmblV1RequestRead } from './GGZOembl/v1/GgzoEmblV1RequestRead';
import { GgzoIntV1DiagnosticReportRead } from './GGZOint/v1/GgzoIntV1DiagnosticReportRead';
import { GgzoIntV1ProcedureRead } from './GGZOint/v1/GgzoIntV1ProcedureRead';
import { GgzoIntV1RequestAddEdit } from './GGZOint/v1/GgzoIntV1RequestAddEdit';
import { GgzoIntV1RequestRead } from './GGZOint/v1/GgzoIntV1RequestRead';
import { GgzvV1DischargeDiagnosticReportAddEdit } from './GGZv/v1/GgzvV1DischargeDiagnosticReportAddEdit';
import { GgzvV1DischargeDiagnosticReportRead } from './GGZv/v1/GgzvV1DischargeDiagnosticReportRead';
import { GgzvV1IntakeDiagnosticReportAddEdit } from './GGZv/v1/GgzvV1IntakeDiagnosticReportAddEdit';
import { GgzvV1IntakeDiagnosticReportRead } from './GGZv/v1/GgzvV1IntakeDiagnosticReportRead';
import { GgzvV1RequestAddEdit } from './GGZv/v1/GgzvV1RequestAddEdit';
import { GgzvV1RequestRead } from './GGZv/v1/GgzvV1RequestRead';
import { GtcV1DiagnosticReportAddEdit } from './GTC/v1/GtcV1DiagnosticReportAddEdit';
import { GtcV1DiagnosticReportRead } from './GTC/v1/GtcV1DiagnosticReportRead';
import { GtcV1RequestAddEdit } from './GTC/v1/GtcV1RequestAddEdit';
import { GtcV1RequestRead } from './GTC/v1/GtcV1RequestRead';
import { GtoV1DiagnosticReportAddEdit } from './GTO/v1/GtoV1DiagnosticReportAddEdit';
import { GtoV1DiagnosticReportRead } from './GTO/v1/GtoV1DiagnosticReportRead';
import { GtoV1ProcedureRead } from './GTO/v1/GtoV1ProcedureRead';
import { GtoV1RequestAddEdit } from './GTO/v1/GtoV1RequestAddEdit';
import { GtoV1RequestRead } from './GTO/v1/GtoV1RequestRead';
import { OcrkV1DiagnosticReportAddEdit } from './OCRK/v1/OcrkV1DiagnosticReportAddEdit';
import { OcrkV1DiagnosticReportRead } from './OCRK/v1/OcrkV1DiagnosticReportRead';
import { OcrkV1RequestRead } from './OCRK/v1/OcrkV1RequestRead';
import { OorkV1ProcedureDiagnosticReportAddEdit } from './OORK/v1/OorkV1ProcedureDiagnosticReportAddEdit';
import { OorkV1ProcedureDiagnosticReportRead } from './OORK/v1/OorkV1ProcedureDiagnosticReportRead';
import { OrthCV1DiagnosticReportAddEdit } from './OrthC/v1/OrthCV1DiagnosticReportAddEdit';
import { OrthCV1DiagnosticReportRead } from './OrthC/v1/OrthCV1DiagnosticReportRead';
import { OrthCV1RequestAddEdit } from './OrthC/v1/OrthCV1RequestAddEdit';
import { OrthCV1RequestRead } from './OrthC/v1/OrthCV1RequestRead';
import { OrthOV1ProcedureAddEdit } from './OrthO/OrthOV1ProcedureAddEdit';
import { OrthOV1ProcedureDiagnosticReportAddEdit } from './OrthO/OrthOV1ProcedureDiagnosticReportAddEdit';
import { OrthOV1ProcedureDiagnosticReportRead } from './OrthO/OrthOV1ProcedureDiagnosticReportRead';
import { OrthOV1ProcedureRead } from './OrthO/OrthOV1ProcedureRead';
import { OrthOV1RequestAddEdit } from './OrthO/OrthOV1RequestAddEdit';
import { OrthOV1RequestRead } from './OrthO/OrthOV1RequestRead';
import { OrthOFolV1ProcedureAddEdit } from './OrthOFol/v1/OrthOFolV1ProcedureAddEdit';
import { OrthOFolV1ProcedureDiagnosticReportAddEdit } from './OrthOFol/v1/OrthOFolV1ProcedureDiagnosticReportAddEdit';
import { OrthOFolV1ProcedureDiagnosticReportRead } from './OrthOFol/v1/OrthOFolV1ProcedureDiagnosticReportRead';
import { OrthOFolV1ProcedureRead } from './OrthOFol/v1/OrthOFolV1ProcedureRead';
import { OrthOFolV1RequestAddEdit } from './OrthOFol/v1/OrthOFolV1RequestAddEdit';
import { OrthOFolV1RequestRead } from './OrthOFol/v1/OrthOFolV1RequestRead';
import { Osasc1V1DiagnosticReportAddEdit } from './OSASC1/v1/Osasc1V1DiagnosticReportAddEdit';
import { Osasc1V1DiagnosticReportRead } from './OSASC1/v1/Osasc1V1DiagnosticReportRead';
import { Osasc1V1RequestRead } from './OSASC1/v1/Osasc1V1RequestRead';
import { Osasc2V1DiagnosticReportAddEdit } from './OSASC2/v1/Osasc2V1DiagnosticReportAddEdit';
import { Osasc2V1DiagnosticReportRead } from './OSASC2/v1/Osasc2V1DiagnosticReportRead';
import { Osasc2V1RequestRead } from './OSASC2/v1/Osasc2V1RequestRead';
import { Osasc2V2DiagnosticReportAddEdit } from './OSASC2/v2/Osasc2V2DiagnosticReportAddEdit';
import { Osasc2V2DiagnosticReportRead } from './OSASC2/v2/Osasc2V2DiagnosticReportRead';
import { Osasc2V2RequestRead } from './OSASC2/v2/Osasc2V2RequestRead';
import { OsaseV1RequestAddEdit } from './OSASE/contact/v1/OsaseV1RequestAddEdit';
import { OsaseV1RequestRead } from './OSASE/contact/v1/OsaseV1RequestRead';
import { OsaseV2RequestAddEdit } from './OSASE/contact/v2/OsaseV2RequestAddEdit';
import { OsaseV2RequestRead } from './OSASE/contact/v2/OsaseV2RequestRead';
import { OsasendV1RequestAddEdit } from './OSASEND/contact/v1/OsasendV1RequestAddEdit';
import { OsasendV1RequestRead } from './OSASEND/contact/v1/OsasendV1RequestRead';
import { OsasnV1RequestAddEdit } from './OSASN/contact/v1/OsasnV1RequestAddEdit';
import { OsasnV1RequestRead } from './OSASN/contact/v1/OsasnV1RequestRead';
import { OsasoV1DiagnosticReportAddEdit } from './OSASO/v1/OsasoV1DiagnosticReportAddEdit';
import { OsasoV1DiagnosticReportRead } from './OSASO/v1/OsasoV1DiagnosticReportRead';
import { OsasoV1ProcedureDiagnosticReportAddEdit } from './OSASO/v1/OsasoV1ProcedureDiagnosticReportAddEdit';
import { OsasoV1ProcedureDiagnosticReportRead } from './OSASO/v1/OsasoV1ProcedureDiagnosticReportRead';
import { OsasoV1ProcedureRead } from './OSASO/v1/OsasoV1ProcedureRead';
import { OsasoV1RequestAddEdit } from './OSASO/v1/OsasoV1RequestAddEdit';
import { OsasoV1RequestRead } from './OSASO/v1/OsasoV1RequestRead';
import { OsasqV1DiagnosticReportRead } from './OSASQ/v1/OsasqV1DiagnosticReportRead';
import { OsasqV1ProcedureDiagnosticReportRead } from './OSASQ/v1/OsasqV1ProcedureDiagnosticReportRead';
import { OsasqV1ProcedureRead } from './OSASQ/v1/OsasqV1ProcedureRead';
import { OsasqV1RequestAddEdit } from './OSASQ/v1/OsasqV1RequestAddEdit';
import { OsasqV1RequestRead } from './OSASQ/v1/OsasqV1RequestRead';
import { OsasvV1RequestAddEdit } from './OSASV/v1/OsasvV1RequestAddEdit';
import { OsasvV1RequestRead } from './OSASV/v1/OsasvV1RequestRead';
import { OsasvcV1RequestAddEdit } from './OSASVC/contact/v1/OsasvcV1RequestAddEdit';
import { OsasvcV1RequestRead } from './OSASVC/contact/v1/OsasvcV1RequestRead';
import { OsasvcV2RequestAddEdit } from './OSASVC/contact/v2/OsasvcV2RequestAddEdit';
import { OsasvcV2RequestRead } from './OSASVC/contact/v2/OsasvcV2RequestRead';
import { OsasvoV1DiagnosticReportAddEdit } from './OSASVO/v1/OsasvoV1DiagnosticReportAddEdit';
import { OsasvoV1DiagnosticReportRead } from './OSASVO/v1/OsasvoV1DiagnosticReportRead';
import { OsasvoV1ProcedureDiagnosticReportAddEdit } from './OSASVO/v1/OsasvoV1ProcedureDiagnosticReportAddEdit';
import { OsasvoV1ProcedureDiagnosticReportRead } from './OSASVO/v1/OsasvoV1ProcedureDiagnosticReportRead';
import { OsasvoV1ProcedureRead } from './OSASVO/v1/OsasvoV1ProcedureRead';
import { OsasvoV1RequestAddEdit } from './OSASVO/v1/OsasvoV1RequestAddEdit';
import { OsasvoV1RequestRead } from './OSASVO/v1/OsasvoV1RequestRead';
import { PilotConsultationV1DiagnosticReportAddEdit } from './PILOT/consultation/v1/PilotConsultationV1DiagnosticReportAddEdit';
import { PilotConsultationV1DiagnosticReportRead } from './PILOT/consultation/v1/PilotConsultationV1DiagnosticReportRead';
import { PilotConsultationV1RequestAddEdit } from './PILOT/consultation/v1/PilotConsultationV1RequestAddEdit';
import { PilotConsultationV1RequestRead } from './PILOT/consultation/v1/PilotConsultationV1RequestRead';
import { PilotContactV1RequestAddEdit } from './PILOT/contact/v1/PilotContactV1RequestAddEdit';
import { PilotContactV1RequestRead } from './PILOT/contact/v1/PilotContactV1RequestRead';
import { PilotExaminationV1DiagnosticReportAddEdit } from './PILOT/examination/v1/PilotExaminationV1DiagnosticReportAddEdit';
import { PilotExaminationV1DiagnosticReportRead } from './PILOT/examination/v1/PilotExaminationV1DiagnosticReportRead';
import { PilotExaminationV1ProcedureAddEdit } from './PILOT/examination/v1/PilotExaminationV1ProcedureAddEdit';
import { PilotExaminationV1ProcedureDiagnosticReportAddEdit } from './PILOT/examination/v1/PilotExaminationV1ProcedureDiagnosticReportAddEdit';
import { PilotExaminationV1ProcedureDiagnosticReportRead } from './PILOT/examination/v1/PilotExaminationV1ProcedureDiagnosticReportRead';
import { PilotExaminationV1ProcedureRead } from './PILOT/examination/v1/PilotExaminationV1ProcedureRead';
import { PilotExaminationV1RequestAddEdit } from './PILOT/examination/v1/PilotExaminationV1RequestAddEdit';
import { PilotExaminationV1RequestRead } from './PILOT/examination/v1/PilotExaminationV1RequestRead';
import { PilotExaminationV1SupervisionEdit } from './PILOT/examination/v1/PilotExaminationV1SupervisionEdit';
import { PilotExaminationV1SupervisionRead } from './PILOT/examination/v1/PilotExaminationV1SupervisionRead';
import { PilotReferralV1DischargeDiagnosticReportAddEdit } from './PILOT/referral/v1/PilotReferralV1DischargeDiagnosticReportAddEdit';
import { PilotReferralV1DischargeDiagnosticReportRead } from './PILOT/referral/v1/PilotReferralV1DischargeDiagnosticReportRead';
import { PilotReferralV1IntakeDiagnosticReportAddEdit } from './PILOT/referral/v1/PilotReferralV1IntakeDiagnosticReportAddEdit';
import { PilotReferralV1IntakeDiagnosticReportRead } from './PILOT/referral/v1/PilotReferralV1IntakeDiagnosticReportRead';
import { PilotReferralV1RequestAddEdit } from './PILOT/referral/v1/PilotReferralV1RequestAddEdit';
import { PilotReferralV1RequestRead } from './PILOT/referral/v1/PilotReferralV1RequestRead';
import { PilotReferralSmallV1RequestAddEdit } from './PILOT/referralSmall/v1/PilotReferralSmallV1RequestAddEdit';
import { PilotReferralSmallV1RequestRead } from './PILOT/referralSmall/v1/PilotReferralSmallV1RequestRead';
import { TcchV1DiagnosticReportAddEdit } from './TCCh/v1/TcchV1DiagnosticReportAddEdit';
import { TcchV1DiagnosticReportRead } from './TCCh/v1/TcchV1DiagnosticReportRead';
import { TcchV1RequestAddEdit } from './TCCh/v1/TcchV1RequestAddEdit';
import { TcchV1RequestRead } from './TCCh/v1/TcchV1RequestRead';
import { TcciV1DiagnosticReportAddEdit } from './TCCi/v1/TcciV1DiagnosticReportAddEdit';
import { TcciV1DiagnosticReportRead } from './TCCi/v1/TcciV1DiagnosticReportRead';
import { TcciV1RequestAddEdit } from './TCCi/v1/TcciV1RequestAddEdit';
import { TcciV1RequestRead } from './TCCi/v1/TcciV1RequestRead';
import { TccrV1DiagnosticReportAddEdit } from './TCCr/v1/TccrV1DiagnosticReportAddEdit';
import { TccrV1DiagnosticReportRead } from './TCCr/v1/TccrV1DiagnosticReportRead';
import { TccrV1RequestAddEdit } from './TCCr/v1/TccrV1RequestAddEdit';
import { TccrV1RequestRead } from './TCCr/v1/TccrV1RequestRead';
import { TcohV1DiagnosticReportAddEdit } from './TCOH/v1/TcohV1DiagnosticReportAddEdit';
import { TcohV1DiagnosticReportRead } from './TCOH/v1/TcohV1DiagnosticReportRead';
import { TcohV1SupervisionEdit } from './TCOH/v1/TcohV1SupervisionEdit';
import { TcohV1SupervisionRead } from './TCOH/v1/TcohV1SupervisionRead';
import { TcohV2DiagnosticReportAddEdit } from './TCOH/v2/TcohV2DiagnosticReportAddEdit';
import { TcohV2DiagnosticReportRead } from './TCOH/v2/TcohV2DiagnosticReportRead';
import { TcohV2ProcedureAddEdit } from './TCOH/v2/TcohV2ProcedureAddEdit';
import { TcohV2ProcedureRead } from './TCOH/v2/TcohV2ProcedureRead';
import { TcohV2RequestAddEdit } from './TCOH/v2/TcohV2RequestAddEdit';
import { TcohV2RequestRead } from './TCOH/v2/TcohV2RequestRead';
import { TcohV2SupervisionEdit } from './TCOH/v2/TcohV2SupervisionEdit';
import { TcohV2SupervisionRead } from './TCOH/v2/TcohV2SupervisionRead';
import { TcorV1DiagnosticReportAddEdit } from './TCOR/v1/TcorV1DiagnosticReportAddEdit';
import { TcorV1DiagnosticReportRead } from './TCOR/v1/TcorV1DiagnosticReportRead';
import { TcorV1ProcedureAddEdit } from './TCOR/v1/TcorV1ProcedureAddEdit';
import { TcorV1ProcedureDiagnosticReportAddEdit } from './TCOR/v1/TcorV1ProcedureDiagnosticReportAddEdit';
import { TcorV1ProcedureDiagnosticReportRead } from './TCOR/v1/TcorV1ProcedureDiagnosticReportRead';
import { TcorV1ProcedureRead } from './TCOR/v1/TcorV1ProcedureRead';
import { TcorV1RequestAddEdit } from './TCOR/v1/TcorV1RequestAddEdit';
import { TcorV1RequestRead } from './TCOR/v1/TcorV1RequestRead';
import { TcorV1SupervisionEdit } from './TCOR/v1/TcorV1SupervisionEdit';
import { TcorV1SupervisionRead } from './TCOR/v1/TcorV1SupervisionRead';
import { TfcV1DiagnosticReportAddEdit } from './TFC/v1/TfcV1DiagnosticReportAddEdit';
import { TfcV1DiagnosticReportRead } from './TFC/v1/TfcV1DiagnosticReportRead';
import { TfcV1RequestAddEdit } from './TFC/v1/TfcV1RequestAddEdit';
import { TfcV1RequestRead } from './TFC/v1/TfcV1RequestRead';
import { TfoV1DiagnosticReportAddEdit } from './TFO/v1/TfoV1DiagnosticReportAddEdit';
import { TfoV1DiagnosticReportRead } from './TFO/v1/TfoV1DiagnosticReportRead';
import { TfoV1ProcedureAddEdit } from './TFO/v1/TfoV1ProcedureAddEdit';
import { TfoV1ProcedureDiagnosticReportAddEdit } from './TFO/v1/TfoV1ProcedureDiagnosticReportAddEdit';
import { TfoV1ProcedureDiagnosticReportRead } from './TFO/v1/TfoV1ProcedureDiagnosticReportRead';
import { TfoV1ProcedureRead } from './TFO/v1/TfoV1ProcedureRead';
import { TfoV1RequestAddEdit } from './TFO/v1/TfoV1RequestAddEdit';
import { TfoV1RequestRead } from './TFO/v1/TfoV1RequestRead';
import { TfoV1SupervisionEdit } from './TFO/v1/TfoV1SupervisionEdit';
import { TfoV1SupervisionRead } from './TFO/v1/TfoV1SupervisionRead';
import { TiecgV1DiagnosticReportAddEdit } from './TIECG/v1/TiecgV1DiagnosticReportAddEdit';
import { TiecgV1DiagnosticReportRead } from './TIECG/v1/TiecgV1DiagnosticReportRead';
import { TiecgV1ProcedureAddEdit } from './TIECG/v1/TiecgV1ProcedureAddEdit';
import { TiecgV1ProcedureDiagnosticReportAddEdit } from './TIECG/v1/TiecgV1ProcedureDiagnosticReportAddEdit';
import { TiecgV1ProcedureDiagnosticReportRead } from './TIECG/v1/TiecgV1ProcedureDiagnosticReportRead';
import { TiecgV1ProcedureRead } from './TIECG/v1/TiecgV1ProcedureRead';
import { TiecgV1RequestAddEdit } from './TIECG/v1/TiecgV1RequestAddEdit';
import { TiecgV1RequestRead } from './TIECG/v1/TiecgV1RequestRead';
import { TiecgV1SupervisionEdit } from './TIECG/v1/TiecgV1SupervisionEdit';
import { TiecgV1SupervisionRead } from './TIECG/v1/TiecgV1SupervisionRead';
import { TocV1DiagnosticReportAddEdit } from './TOC/v1/TocV1DiagnosticReportAddEdit';
import { TocV1DiagnosticReportRead } from './TOC/v1/TocV1DiagnosticReportRead';
import { TocV1RequestRead } from './TOC/v1/TocV1RequestRead';
import { TooV1ProcedureAddEdit } from './TOO/v1/TooV1ProcedureAddEdit';
import { TooV1ProcedureDiagnosticReportAddEdit } from './TOO/v1/TooV1ProcedureDiagnosticReportAddEdit';
import { TooV1ProcedureDiagnosticReportRead } from './TOO/v1/TooV1ProcedureDiagnosticReportRead';
import { TooV1ProcedureRead } from './TOO/v1/TooV1ProcedureRead';
import { TooV1RequestAddEdit } from './TOO/v1/TooV1RequestAddEdit';
import { TooV1RequestRead } from './TOO/v1/TooV1RequestRead';
import { TooV1SupervisionRead } from './TOO/v1/TooV1SupervisionRead';
import { TovV1DischargeDiagnosticReportAddEdit } from './TOV/v1/TovV1DischargeDiagnosticReportAddEdit';
import { TovV1DischargeDiagnosticReportRead } from './TOV/v1/TovV1DischargeDiagnosticReportRead';
import { TovV1IntakeDiagnosticReportAddEdit } from './TOV/v1/TovV1IntakeDiagnosticReportAddEdit';
import { TovV1IntakeDiagnosticReportRead } from './TOV/v1/TovV1IntakeDiagnosticReportRead';
import { TovV1RequestAddEdit } from './TOV/v1/TovV1RequestAddEdit';
import { TovV1RequestRead } from './TOV/v1/TovV1RequestRead';
import { TpcV1DiagnosticReportAddEdit } from './TPC/v1/TpcV1DiagnosticReportAddEdit';
import { TpcV1DiagnosticReportRead } from './TPC/v1/TpcV1DiagnosticReportRead';
import { TpcV1RequestAddEdit } from './TPC/v1/TpcV1RequestAddEdit';
import { TpcV1RequestRead } from './TPC/v1/TpcV1RequestRead';
import { TpoV1DiagnosticReportAddEdit } from './TPO/v1/TpoV1DiagnosticReportAddEdit';
import { TpoV1DiagnosticReportRead } from './TPO/v1/TpoV1DiagnosticReportRead';
import { TpoV1ProcedureAddEdit } from './TPO/v1/TpoV1ProcedureAddEdit';
import { TpoV1ProcedureDiagnosticReportAddEdit } from './TPO/v1/TpoV1ProcedureDiagnosticReportAddEdit';
import { TpoV1ProcedureDiagnosticReportRead } from './TPO/v1/TpoV1ProcedureDiagnosticReportRead';
import { TpoV1ProcedureRead } from './TPO/v1/TpoV1ProcedureRead';
import { TpoV1RequestAddEdit } from './TPO/v1/TpoV1RequestAddEdit';
import { TpoV1RequestRead } from './TPO/v1/TpoV1RequestRead';
import { TpoV1SupervisionEdit } from './TPO/v1/TpoV1SupervisionEdit';
import { TpoV1SupervisionRead } from './TPO/v1/TpoV1SupervisionRead';

export function loadCustomControl(
    version: number,
    customControlEntity: CustomControlEntity.SupervisionEdit,
    serviceCode: ServiceCode,
    serviceType: ServiceType
): (props: ICustomControlSupervisionEditProps) => JSX.Element;
export function loadCustomControl(
    version: number,
    customControlEntity: CustomControlEntity.SupervisionRead,
    serviceCode: ServiceCode,
    serviceType: ServiceType
): (props: ICustomControlSupervisionReadProps) => JSX.Element;
export function loadCustomControl(
    version: number,
    customControlEntity: CustomControlEntity.ProcedureDiagnosticReportRead,
    serviceCode: ServiceCode,
    serviceType: ServiceType
): (props: ICustomControlProcedureDiagnosticReportReadProps) => JSX.Element;
export function loadCustomControl(
    version: number,
    customControlEntity: CustomControlEntity.ProcedureDiagnosticReportAddEdit,
    serviceCode: ServiceCode,
    serviceType: ServiceType
): (props: ICustomControlProcedureDiagnosticReportAddEditProps) => JSX.Element;
export function loadCustomControl(
    version: number,
    customControlEntity: CustomControlEntity.ProcedureAddEdit,
    serviceCode: ServiceCode,
    serviceType: ServiceType
): (props: ICustomControlProcedureAddEditProps) => JSX.Element;
export function loadCustomControl(
    version: number,
    customControlEntity: CustomControlEntity.ProcedureRead,
    serviceCode: ServiceCode,
    serviceType: ServiceType
): (props: ICustomControlProcedureReadProps) => JSX.Element;
export function loadCustomControl(
    version: number,
    customControlEntity: CustomControlEntity.DiagnosticReportAddEdit,
    serviceCode: ServiceCode,
    serviceType: ServiceType,
    category: ReportCategories
): (props: ICustomControlDiagnosticReportAddEditProps) => JSX.Element;
export function loadCustomControl(
    version: number,
    customControlEntity: CustomControlEntity.DiagnosticReportRead,
    serviceCode: ServiceCode,
    serviceType: ServiceType,
    category: ReportCategories
): (props: ICustomControlDiagnosticReportReadProps) => JSX.Element;
export function loadCustomControl(
    version: number,
    customControlEntity: CustomControlEntity.RequestAddEdit,
    serviceCode: ServiceCode,
    serviceType: ServiceType
): (props: ICustomControlRequestAddEditProps) => JSX.Element;
export function loadCustomControl(
    version: number,
    customControlEntity: CustomControlEntity.RequestRead,
    serviceCode: ServiceCode,
    serviceType: ServiceType
): (props: ICustomControlRequestReadProps) => JSX.Element;
export function loadCustomControl(
    version: number,
    customControlEntity: CustomControlEntity,
    serviceCode: ServiceCode,
    serviceType: ServiceType,
    category?: ReportCategories
) {
    if (
        !category &&
        (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit ||
            customControlEntity === CustomControlEntity.DiagnosticReportRead)
    ) {
        throw new Error(`Category missing for ${customControlEntity} in loadCustomControl`);
    }

    const components = {
        GgzcgV1DiagnosticReportAddEdit: GgzcgV1DiagnosticReportAddEdit,
        GgzcgV1DiagnosticReportRead: GgzcgV1DiagnosticReportRead,
        GgzcgV1RequestAddEdit: GgzcgV1RequestAddEdit,
        GgzcgV1RequestRead: GgzcgV1RequestRead,
        GgzctV1RequestAddEdit: GgzctV1RequestAddEdit,
        GgzctV1RequestRead: GgzctV1RequestRead,
        GgzctV1DiagnosticReportAddEdit: GgzctV1DiagnosticReportAddEdit,
        GgzctV1DiagnosticReportRead: GgzctV1DiagnosticReportRead,
        GgzctriageV1RequestAddEdit: GgzctriageV1RequestAddEdit,
        GgzctriageV1RequestRead: GgzctriageV1RequestRead,
        GgzctriageV1DiagnosticReportAddEdit: GgzctriageV1DiagnosticReportAddEdit,
        GgzctriageV1DiagnosticReportRead: GgzctriageV1DiagnosticReportRead,
        Ggzcf2fV1RequestRead: Ggzcf2fV1RequestRead,
        Ggzcf2fV1RequestAddEdit: Ggzcf2fV1RequestAddEdit,
        Ggzcf2fV1DiagnosticReportAddEdit: Ggzcf2fV1DiagnosticReportAddEdit,
        Ggzcf2fV1DiagnosticReportRead: Ggzcf2fV1DiagnosticReportRead,
        GgzcmdoV1RequestAddEdit: GgzcmdoV1RequestAddEdit,
        GgzcmdoV1RequestRead: GgzcmdoV1RequestRead,
        GgzcmdoV1DiagnosticReportAddEdit: GgzcmdoV1DiagnosticReportAddEdit,
        GgzcmdoV1DiagnosticReportRead: GgzcmdoV1DiagnosticReportRead,
        GgzvV1RequestAddEdit: GgzvV1RequestAddEdit,
        GgzvV1RequestRead: GgzvV1RequestRead,
        GgzvV1IntakeDiagnosticReportAddEdit: GgzvV1IntakeDiagnosticReportAddEdit,
        GgzvV1IntakeDiagnosticReportRead: GgzvV1IntakeDiagnosticReportRead,
        GgzvV1DischargeDiagnosticReportAddEdit: GgzvV1DischargeDiagnosticReportAddEdit,
        GgzvV1DischargeDiagnosticReportRead: GgzvV1DischargeDiagnosticReportRead,
        GgzoIntV1RequestAddEdit: GgzoIntV1RequestAddEdit,
        GgzoIntV1RequestRead: GgzoIntV1RequestRead,
        GgzoIntV1ProcedureRead: GgzoIntV1ProcedureRead,
        GgzoIntV1DiagnosticReportRead: GgzoIntV1DiagnosticReportRead,
        GgzoEmblV1RequestAddEdit: GgzoEmblV1RequestAddEdit,
        GgzoEmblV1RequestRead: GgzoEmblV1RequestRead,
        GgzoEmblV1ProcedureRead: GgzoEmblV1ProcedureRead,
        GgzoEmblV1DiagnosticReportRead: GgzoEmblV1DiagnosticReportRead,
        GgzbTherV1RequestAddEdit: GgzbTherV1RequestAddEdit,
        GgzbTherV1RequestRead: GgzbTherV1RequestRead,
        GtoV1RequestAddEdit: GtoV1RequestAddEdit,
        GtoV1RequestRead: GtoV1RequestRead,
        GtoV1ProcedureRead: GtoV1ProcedureRead,
        GtoV1DiagnosticReportAddEdit: GtoV1DiagnosticReportAddEdit,
        GtoV1DiagnosticReportRead: GtoV1DiagnosticReportRead,
        Osasc1V1DiagnosticReportAddEdit: Osasc1V1DiagnosticReportAddEdit,
        Osasc1V1DiagnosticReportRead: Osasc1V1DiagnosticReportRead,
        Osasc1V1RequestRead: Osasc1V1RequestRead,
        Osasc2V1DiagnosticReportAddEdit: Osasc2V1DiagnosticReportAddEdit,
        Osasc2V1DiagnosticReportRead: Osasc2V1DiagnosticReportRead,
        Osasc2V1RequestRead: Osasc2V1RequestRead,
        Osasc2V2DiagnosticReportAddEdit: Osasc2V2DiagnosticReportAddEdit,
        Osasc2V2DiagnosticReportRead: Osasc2V2DiagnosticReportRead,
        Osasc2V2RequestRead: Osasc2V2RequestRead,
        OsasnV1RequestRead: OsasnV1RequestRead,
        OsasnV1RequestAddEdit: OsasnV1RequestAddEdit,
        OsasoV1ProcedureDiagnosticReportAddEdit: OsasoV1ProcedureDiagnosticReportAddEdit,
        OsasoV1ProcedureDiagnosticReportRead: OsasoV1ProcedureDiagnosticReportRead,
        OsasoV1RequestRead: OsasoV1RequestRead,
        OsasoV1RequestAddEdit: OsasoV1RequestAddEdit,
        OsasoV1ProcedureRead: OsasoV1ProcedureRead,
        OsasoV1DiagnosticReportAddEdit: OsasoV1DiagnosticReportAddEdit,
        OsasoV1DiagnosticReportRead: OsasoV1DiagnosticReportRead,
        OsasvoV1ProcedureDiagnosticReportAddEdit: OsasvoV1ProcedureDiagnosticReportAddEdit,
        OsasvoV1ProcedureDiagnosticReportRead: OsasvoV1ProcedureDiagnosticReportRead,
        OsasvoV1RequestRead: OsasvoV1RequestRead,
        OsasvoV1RequestAddEdit: OsasvoV1RequestAddEdit,
        OsasvoV1ProcedureRead: OsasvoV1ProcedureRead,
        OsasvoV1DiagnosticReportAddEdit: OsasvoV1DiagnosticReportAddEdit,
        OsasvoV1DiagnosticReportRead: OsasvoV1DiagnosticReportRead,
        OsasqV1RequestRead: OsasqV1RequestRead,
        OsasqV1RequestAddEdit: OsasqV1RequestAddEdit,
        OsasqV1ProcedureRead: OsasqV1ProcedureRead,
        OsasqV1DiagnosticReportRead: OsasqV1DiagnosticReportRead,
        OsasqV1ProcedureDiagnosticReportRead: OsasqV1ProcedureDiagnosticReportRead,
        OsasvV1RequestAddEdit: OsasvV1RequestAddEdit,
        OsasvV1RequestRead: OsasvV1RequestRead,
        OsasvcV1RequestAddEdit: OsasvcV1RequestAddEdit,
        OsasvcV1RequestRead: OsasvcV1RequestRead,
        OsasvcV2RequestAddEdit: OsasvcV2RequestAddEdit,
        OsasvcV2RequestRead: OsasvcV2RequestRead,
        PilotConsultationV1DiagnosticReportAddEdit: PilotConsultationV1DiagnosticReportAddEdit,
        PilotConsultationV1DiagnosticReportRead: PilotConsultationV1DiagnosticReportRead,
        PilotConsultationV1RequestAddEdit: PilotConsultationV1RequestAddEdit,
        PilotConsultationV1RequestRead: PilotConsultationV1RequestRead,
        PilotContactV1RequestAddEdit: PilotContactV1RequestAddEdit,
        PilotContactV1RequestRead: PilotContactV1RequestRead,
        PilotExaminationV1DiagnosticReportAddEdit: PilotExaminationV1DiagnosticReportAddEdit,
        PilotExaminationV1DiagnosticReportRead: PilotExaminationV1DiagnosticReportRead,
        PilotExaminationV1ProcedureAddEdit: PilotExaminationV1ProcedureAddEdit,
        PilotExaminationV1ProcedureDiagnosticReportAddEdit: PilotExaminationV1ProcedureDiagnosticReportAddEdit,
        PilotExaminationV1ProcedureDiagnosticReportRead: PilotExaminationV1ProcedureDiagnosticReportRead,
        PilotExaminationV1ProcedureRead: PilotExaminationV1ProcedureRead,
        PilotExaminationV1RequestAddEdit: PilotExaminationV1RequestAddEdit,
        PilotExaminationV1RequestRead: PilotExaminationV1RequestRead,
        PilotExaminationV1SupervisionEdit: PilotExaminationV1SupervisionEdit,
        PilotExaminationV1SupervisionRead: PilotExaminationV1SupervisionRead,
        PilotReferralV1IntakeDiagnosticReportAddEdit: PilotReferralV1IntakeDiagnosticReportAddEdit,
        PilotReferralV1IntakeDiagnosticReportRead: PilotReferralV1IntakeDiagnosticReportRead,
        PilotReferralV1DischargeDiagnosticReportAddEdit: PilotReferralV1DischargeDiagnosticReportAddEdit,
        PilotReferralV1DischargeDiagnosticReportRead: PilotReferralV1DischargeDiagnosticReportRead,
        PilotReferralV1RequestAddEdit: PilotReferralV1RequestAddEdit,
        PilotReferralV1RequestRead: PilotReferralV1RequestRead,
        PilotReferralSmallV1RequestAddEdit: PilotReferralSmallV1RequestAddEdit,
        PilotReferralSmallV1RequestRead: PilotReferralSmallV1RequestRead,
        TcchV1DiagnosticReportAddEdit: TcchV1DiagnosticReportAddEdit,
        TcchV1DiagnosticReportRead: TcchV1DiagnosticReportRead,
        TcchV1RequestAddEdit: TcchV1RequestAddEdit,
        TcchV1RequestRead: TcchV1RequestRead,
        TcciV1DiagnosticReportAddEdit: TcciV1DiagnosticReportAddEdit,
        TcciV1DiagnosticReportRead: TcciV1DiagnosticReportRead,
        TcciV1RequestAddEdit: TcciV1RequestAddEdit,
        TcciV1RequestRead: TcciV1RequestRead,
        TccrV1DiagnosticReportAddEdit: TccrV1DiagnosticReportAddEdit,
        TccrV1DiagnosticReportRead: TccrV1DiagnosticReportRead,
        TccrV1RequestAddEdit: TccrV1RequestAddEdit,
        TccrV1RequestRead: TccrV1RequestRead,
        TcohV1DiagnosticReportAddEdit: TcohV1DiagnosticReportAddEdit,
        TcohV1DiagnosticReportRead: TcohV1DiagnosticReportRead,
        TcohV2DiagnosticReportAddEdit: TcohV2DiagnosticReportAddEdit,
        TcohV2DiagnosticReportRead: TcohV2DiagnosticReportRead,
        TcohV1ProcedureAddEdit: TcohV2ProcedureAddEdit,
        TcohV2ProcedureAddEdit: TcohV2ProcedureAddEdit,
        TcohV1ProcedureRead: TcohV2ProcedureRead,
        TcohV2ProcedureRead: TcohV2ProcedureRead,
        TcohV1RequestAddEdit: TcohV2RequestAddEdit,
        TcohV2RequestAddEdit: TcohV2RequestAddEdit,
        TcohV1RequestRead: TcohV2RequestRead,
        TcohV2RequestRead: TcohV2RequestRead,
        TcohV1SupervisionEdit: TcohV1SupervisionEdit,
        TcohV1SupervisionRead: TcohV1SupervisionRead,
        TcohV2SupervisionEdit: TcohV2SupervisionEdit,
        TcohV2SupervisionRead: TcohV2SupervisionRead,
        TcorV1DiagnosticReportAddEdit: TcorV1DiagnosticReportAddEdit,
        TcorV1DiagnosticReportRead: TcorV1DiagnosticReportRead,
        TcorV1ProcedureAddEdit: TcorV1ProcedureAddEdit,
        TcorV1ProcedureDiagnosticReportAddEdit: TcorV1ProcedureDiagnosticReportAddEdit,
        TcorV1ProcedureDiagnosticReportRead: TcorV1ProcedureDiagnosticReportRead,
        TcorV1ProcedureRead: TcorV1ProcedureRead,
        TcorV1RequestAddEdit: TcorV1RequestAddEdit,
        TcorV1RequestRead: TcorV1RequestRead,
        TcorV1SupervisionEdit: TcorV1SupervisionEdit,
        TcorV1SupervisionRead: TcorV1SupervisionRead,
        TfcV1RequestAddEdit: TfcV1RequestAddEdit,
        TfcV1RequestRead: TfcV1RequestRead,
        TfcV1DiagnosticReportAddEdit: TfcV1DiagnosticReportAddEdit,
        TfcV1DiagnosticReportRead: TfcV1DiagnosticReportRead,
        TfoV1DiagnosticReportAddEdit: TfoV1DiagnosticReportAddEdit,
        TfoV1DiagnosticReportRead: TfoV1DiagnosticReportRead,
        TfoV1ProcedureAddEdit: TfoV1ProcedureAddEdit,
        TfoV1ProcedureDiagnosticReportAddEdit: TfoV1ProcedureDiagnosticReportAddEdit,
        TfoV1ProcedureDiagnosticReportRead: TfoV1ProcedureDiagnosticReportRead,
        TfoV1ProcedureRead: TfoV1ProcedureRead,
        TfoV1RequestAddEdit: TfoV1RequestAddEdit,
        TfoV1RequestRead: TfoV1RequestRead,
        TfoV1SupervisionEdit: TfoV1SupervisionEdit,
        TfoV1SupervisionRead: TfoV1SupervisionRead,
        TiecgV1DiagnosticReportAddEdit: TiecgV1DiagnosticReportAddEdit,
        TiecgV1DiagnosticReportRead: TiecgV1DiagnosticReportRead,
        TiecgV1ProcedureAddEdit: TiecgV1ProcedureAddEdit,
        TiecgV1ProcedureDiagnosticReportAddEdit: TiecgV1ProcedureDiagnosticReportAddEdit,
        TiecgV1ProcedureDiagnosticReportRead: TiecgV1ProcedureDiagnosticReportRead,
        TiecgV1ProcedureRead: TiecgV1ProcedureRead,
        TiecgV1RequestAddEdit: TiecgV1RequestAddEdit,
        TiecgV1RequestRead: TiecgV1RequestRead,
        TiecgV1SupervisionEdit: TiecgV1SupervisionEdit,
        TiecgV1SupervisionRead: TiecgV1SupervisionRead,
        TocV1DiagnosticReportAddEdit: TocV1DiagnosticReportAddEdit,
        TocV1DiagnosticReportRead: TocV1DiagnosticReportRead,
        TocV1RequestRead: TocV1RequestRead,
        TooV1ProcedureDiagnosticReportAddEdit: TooV1ProcedureDiagnosticReportAddEdit,
        TooV1ProcedureDiagnosticReportRead: TooV1ProcedureDiagnosticReportRead,
        TooV1ProcedureAddEdit: TooV1ProcedureAddEdit,
        TooV1ProcedureRead: TooV1ProcedureRead,
        TooV1RequestAddEdit: TooV1RequestAddEdit,
        TooV1RequestRead: TooV1RequestRead,
        TooV1SupervisionRead: TooV1SupervisionRead,
        TpcV1DiagnosticReportAddEdit: TpcV1DiagnosticReportAddEdit,
        TpcV1DiagnosticReportRead: TpcV1DiagnosticReportRead,
        TpcV1RequestAddEdit: TpcV1RequestAddEdit,
        TpcV1RequestRead: TpcV1RequestRead,
        TpoV1DiagnosticReportAddEdit: TpoV1DiagnosticReportAddEdit,
        TpoV1DiagnosticReportRead: TpoV1DiagnosticReportRead,
        TpoV1ProcedureAddEdit: TpoV1ProcedureAddEdit,
        TpoV1ProcedureDiagnosticReportAddEdit: TpoV1ProcedureDiagnosticReportAddEdit,
        TpoV1ProcedureDiagnosticReportRead: TpoV1ProcedureDiagnosticReportRead,
        TpoV1ProcedureRead: TpoV1ProcedureRead,
        TpoV1RequestAddEdit: TpoV1RequestAddEdit,
        TpoV1RequestRead: TpoV1RequestRead,
        TpoV1SupervisionEdit: TpoV1SupervisionEdit,
        TpoV1SupervisionRead: TpoV1SupervisionRead,
        TovV1RequestAddEdit: TovV1RequestAddEdit,
        TovV1RequestRead: TovV1RequestRead,
        TovV1IntakeDiagnosticReportAddEdit: TovV1IntakeDiagnosticReportAddEdit,
        TovV1IntakeDiagnosticReportRead: TovV1IntakeDiagnosticReportRead,
        TovV1DischargeDiagnosticReportAddEdit: TovV1DischargeDiagnosticReportAddEdit,
        TovV1DischargeDiagnosticReportRead: TovV1DischargeDiagnosticReportRead,
        GtcV1DiagnosticReportAddEdit: GtcV1DiagnosticReportAddEdit,
        GtcV1DiagnosticReportRead: GtcV1DiagnosticReportRead,
        GtcV1RequestAddEdit: GtcV1RequestAddEdit,
        GtcV1RequestRead: GtcV1RequestRead,
        DermaCV1RequestAddEdit: DermaCV1RequestAddEdit,
        DermaCV1RequestRead: DermaCV1RequestRead,
        DermaCV1DiagnosticReportAddEdit: DermaCV1DiagnosticReportAddEdit,
        DermaCV1DiagnosticReportRead: DermaCV1DiagnosticReportRead,
        DermaSnelCV1RequestAddEdit: DermaSnelCV1RequestAddEdit,
        DermaSnelCV1RequestRead: DermaSnelCV1RequestRead,
        DermaSnelCV1DiagnosticReportAddEdit: DermaSnelCV1DiagnosticReportAddEdit,
        DermaSnelCV1DiagnosticReportRead: DermaSnelCV1DiagnosticReportRead,
        DermaCscV1RequestAddEdit: DermaCscV1RequestAddEdit,
        DermaCscV1RequestRead: DermaCscV1RequestRead,
        DermaCscV1DiagnosticReportAddEdit: DermaCscV1DiagnosticReportAddEdit,
        DermaCscV1DiagnosticReportRead: DermaCscV1DiagnosticReportRead,
        DermaSnelCscV1RequestAddEdit: DermaSnelCscV1RequestAddEdit,
        DermaSnelCscV1RequestRead: DermaSnelCscV1RequestRead,
        DermaSnelCscV1DiagnosticReportAddEdit: DermaSnelCscV1DiagnosticReportAddEdit,
        DermaSnelCscV1DiagnosticReportRead: DermaSnelCscV1DiagnosticReportRead,
        DermaCwondV1RequestAddEdit: DermaCwondV1RequestAddEdit,
        DermaCwondV1RequestRead: DermaCwondV1RequestRead,
        DermaCwondV1DiagnosticReportAddEdit: DermaCwondV1DiagnosticReportAddEdit,
        DermaCwondV1DiagnosticReportRead: DermaCwondV1DiagnosticReportRead,
        DermaOthV1RequestAddEdit: DermaOthV1RequestAddEdit,
        DermaOthV1RequestRead: DermaOthV1RequestRead,
        DermaOthV1ProcedureRead: DermaOthV1ProcedureRead,
        DermaOthV1DiagnosticReportAddEdit: DermaOthV1DiagnosticReportAddEdit,
        DermaOthV1DiagnosticReportRead: DermaOthV1DiagnosticReportRead,
        OsasendV1RequestAddEdit: OsasendV1RequestAddEdit,
        OsasendV1RequestRead: OsasendV1RequestRead,
        GGZbMindV1RequestRead: GgzbMindV1RequestRead,
        OsaseV1RequestAddEdit: OsaseV1RequestAddEdit,
        OsaseV1RequestRead: OsaseV1RequestRead,
        OsaseV2RequestAddEdit: OsaseV2RequestAddEdit,
        OsaseV2RequestRead: OsaseV2RequestRead,
        OrthOV1RequestAddEdit: OrthOV1RequestAddEdit,
        OrthOV1RequestRead: OrthOV1RequestRead,
        OrthOV1ProcedureAddEdit: OrthOV1ProcedureAddEdit,
        OrthOV1ProcedureRead: OrthOV1ProcedureRead,
        OrthOV1ProcedureDiagnosticReportAddEdit: OrthOV1ProcedureDiagnosticReportAddEdit,
        OrthOV1ProcedureDiagnosticReportRead: OrthOV1ProcedureDiagnosticReportRead,
        OrthCV1DiagnosticReportRead: OrthCV1DiagnosticReportRead,
        OrthCV1DiagnosticReportAddEdit: OrthCV1DiagnosticReportAddEdit,
        OrthOFolV1RequestAddEdit: OrthOFolV1RequestAddEdit,
        OrthOFolV1RequestRead: OrthOFolV1RequestRead,
        OrthOFolV1ProcedureAddEdit: OrthOFolV1ProcedureAddEdit,
        OrthOFolV1ProcedureRead: OrthOFolV1ProcedureRead,
        OrthOFolV1ProcedureDiagnosticReportAddEdit: OrthOFolV1ProcedureDiagnosticReportAddEdit,
        OrthOFolV1ProcedureDiagnosticReportRead: OrthOFolV1ProcedureDiagnosticReportRead,
        OrthCV1RequestAddEdit: OrthCV1RequestAddEdit,
        OrthCV1RequestRead: OrthCV1RequestRead,
        OorkV1ProcedureDiagnosticReportAddEdit: OorkV1ProcedureDiagnosticReportAddEdit,
        OorkV1ProcedureDiagnosticReportRead: OorkV1ProcedureDiagnosticReportRead,
        OcrkV1RequestRead: OcrkV1RequestRead,
        OcrkV1DiagnosticReportAddEdit: OcrkV1DiagnosticReportAddEdit,
        OcrkV1DiagnosticReportRead: OcrkV1DiagnosticReportRead,
    };

    const name = new RegExp(`${serviceCode}V${version}${customControlEntity}`, 'i');
    const nameWithServiceType = new RegExp(`${serviceCode}${serviceType}V${version}${customControlEntity}`, 'i');
    const nameWithCategory = new RegExp(`${serviceCode}V${version}${category}${customControlEntity}`, 'i');
    const nameWithServiceTypeAndCategory = new RegExp(
        `${serviceCode}${serviceType}V${version}${category}${customControlEntity}`,
        'i'
    );
    const matches = Object.entries(components).filter(
        ([key]) =>
            key.match(name) ||
            key.match(nameWithServiceType) ||
            key.match(nameWithCategory) ||
            key.match(nameWithServiceTypeAndCategory)
    );
    if (matches.length === 1) {
        return matches[0][1];
    }

    return () => (
        <FormParagraph>{`Expected to find custom controls for ${serviceCode} ${serviceType} ${customControlEntity} with version ${version}`}</FormParagraph>
    );
}
